import { config } from "Utils/config";

const ACTIONS = {
    SET_ALL: "set_all",
    ADD_MENU: "add_menu",
    SET_VISIBILITY: "set_visibility"
};

const navSubMenuReducer = (state, action) => {
    config.isDebugEnabled && console.log("navSubMenuReducer", state, action);
    
    switch (action.type) {
        case ACTIONS.SET_ALL: {
            return {
                ...action.data
            };
        }

        case ACTIONS.ADD_MENU: {
            return {
                ...state,
                [action.subMenuKey]: {
                    subMenuKey: action.subMenuKey,
                    subMenuItems: action.subMenuItems,
                    label: action.label,
                    visible: action.visible,
                    trigger: ''
                }
            };
        }

        case ACTIONS.SET_VISIBILITY: {
            return {
                ...state,
                [action.subMenuKey]: {
                    ...state[action.subMenuKey],
                    visible: action.visible,
                    trigger: action.trigger
                }
            };
        }
    }
}

const navMenuReducer = (state, action) => {
    config.isDebugEnabled && console.log("navMenuReducer", state, action);

    switch (action.type) {
        case ACTIONS.SET_ALL: {
            return {
                ...action.data
            };
        }

        case ACTIONS.ADD_MENU: {
            return {
                ...state,
                visible: action.visible,
                trigger: ''
            };
        }

        case ACTIONS.SET_VISIBILITY: {
            return {
                ...state,
                visible: action.visible,
                trigger: action.trigger
            };
        }

        
    }
}

export {ACTIONS, navSubMenuReducer, navMenuReducer};